/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import {
  Box, Button,
  Card,
  CardContent,
  Grid,
  InputAdornment,
  Modal,
  TextField,
  Typography
} from "@mui/material";
import axios from "axios";
import TimelineItem from "components/Icon/TimelineItem";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useDispatch } from "react-redux";
import { useNavigate, } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { appConstants } from "utils/appConstants";

import { loadingAction } from "ReduxReducers/loadingReducer";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import { getLegalDocumets, uploadLegalDocumentsFormat, deleteLegalDocumentFormat } from "utils/api";
import { getScreenRight } from "utils/generic";
import { showResMsg } from "utils/generic";
import IconMenu from "components/CustomMaterialMenu/Custom";
import ShowSwalWithButtons from "components/SwalAlert/swalPopupWithButtons";

const errMsg = {
  color: `red`,
  fontSize: `11px`,
};
const pdfStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%", // increase the width
  height: "90%x", // increase the height
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
let fetchedDefault;
let SCREEN_RIGHT;


function DefaultSetting() {
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  const { barColor, tableBorder } = getColorMappings(sidenavColor);
  const customStyles = {
    table: {
      style: {
        borderColor: tableBorder,
      },
    },
    headRow: {
      style: {
        color: darkMode ? "white" : "white",
        background: barColor,
      },
    },
    headCells: {
      style: {
        paddingLeft: "10px",
        paddingRight: "10px",
        fontWeight: "bold",
        fontSize: "14px",
        color: "white",
      },
    },
  };

  const [fileName, setFileName] = useState("");
  const [showUploadedFileFlag, setShowUploadedFileFlag] = useState(false);

  const dispatch = useDispatch();
  let navigate = useNavigate();
  const [viewDocumentInModal, setViewDocumentInModal] = useState(false);
  const [loginDetails, setLoginDetails] = useState(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")));


  const [getDocumentFileURL, setSetDocumentFileURL] = useState('');

  const [file, setFile] = useState(null);
  const [documentFormat, setDocuments] = useState([]);
  const [values, setValues] = useState({
    token: useState(sessionStorage.getItem("TOKEN")),
    documentName: "",
    documentRemark: "",
    selectedID: undefined,
  });

  useEffect(() => {
    const fetchData = async () => {

      setLoginDetails(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")));

      await Promise.all([
        LoadInitialData(),
        getRight()
      ]);
    };
    fetchData();
  }, [dispatch]);

  async function getRight() {
    SCREEN_RIGHT = await getScreenRight("Upload Legal Documents");
  }
  const LoadInitialData = async () => {
    getLegalDocumets(values, data => {
      setDocuments(data.Result_Output);
    }, dispatch)
  };

  const handleChange = (name) => (event) => {
    let value = event.target.value;
    if (event.target.validity && event.target.validity.valid) {
      setValues({ ...values, [name]: value });
    } else if (event.target.validity === undefined) {
      setValues({ ...values, [name]: value });
    }
  }
  const [fileError, setFileError] = useState('');
  const saveFile = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.size > 10 * 1024 * 1024) {
        setFileError('File size should be less than 10 MB');
        return;
      } else {
        setFileError('');
        setFile(file);
        document.getElementById("legalDocument").value = file.name;
      }
    } else {
      setFileError('');
    }
  };
  const addDocument = async () => {
    if (isButtonDisabled) {
      showResMsg("Document Name or File is missing.", 2000, false);
      return
    }
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("documentName", values.documentName);
      formData.append("documentRemark", values.documentRemark);
      values.selectedID && formData.append("documentID", values.selectedID);

      uploadLegalDocumentsFormat(formData, (data) => {
        showResMsg(data.Result_Message, 2000, data.Result_Status);
        data.Result_Status && LoadInitialData();
        setValues({ ...values, documentName: "", documentRemark: "", selectedID: undefined, });
        document.getElementById("legalDocument").value = "";
      }, dispatch)

    } catch (error) {
      dispatch(loadingAction(false))
      console.log("Upload Document Error:", error.message);
    }
  }
  const handleEditDocument = (selectedDocRow) => {
    ShowSwalWithButtons(
      'Are you sure?', `Would you like to edit "${selectedDocRow.documentName}" file?`, 'warning', darkMode,
      () => {
        setValues({ ...values, documentName: selectedDocRow.documentName, documentRemark: selectedDocRow.documentRemark, selectedID: selectedDocRow._id });
      }
    );

    // Swal.fire({
    //   title: "Are you sure?",
    //   text: `Would you like to edit "${selectedDocRow.documentName}" file?`,
    //   icon: "warning",
    //   showCancelButton: true,
    //   confirmButtonColor: "#4CAF50",
    //   cancelButtonColor: "#6c757d",
    //   confirmButtonText: "Yes",
    //   cancelButtonText: "No",
    //   reverseButtons: true,
    //   customClass: {
    //     title: darkMode ? "swal-title-dark" : "swal-title-light",
    //     popup: darkMode ? "darkPopup" : "whitePopup",
    //   }
    // }).then(async (value) => {
    //   if (value.isConfirmed) {
    //     setValues({ ...values, documentName: selectedDocRow.documentName, documentRemark: selectedDocRow.documentRemark, selectedID: selectedDocRow._id });
    //   }
    // });

  }
  const handleViewDocument = (selectedDocRow) => {
    setSetDocumentFileURL(appConstants.baseURL + 'parameterSetting/viewFile?fileName=/' + selectedDocRow.documentFileName);
    setViewDocumentInModal(true);
  };

  const handleDeleteDocument = async (selectedDocRow) => {
    ShowSwalWithButtons(
      'Are you sure?', `Would you like to delete "${selectedDocRow.documentName}" file?`, 'warning', darkMode,
      () => {
        deleteLegalDocumentFormat({ documentID: selectedDocRow._id }, (data) => {
          showResMsg(data.Result_Message, 2000, data.Result_Status);
          data.Result_Status && LoadInitialData();
        }, dispatch)
      }
    );
    // Swal.fire({
    //   title: "Are you sure?",
    //   text: `Would you like to delete "${selectedDocRow.documentName}" file?`,
    //   icon: "warning",
    //   showCancelButton: true,
    //   confirmButtonColor: "#4CAF50",
    //   cancelButtonColor: "#6c757d",
    //   confirmButtonText: "Yes",
    //   cancelButtonText: "No",
    //   reverseButtons: true,
    //   customClass: {
    //     title: darkMode ? "swal-title-dark" : "swal-title-light",
    //     popup: darkMode ? "darkPopup" : "whitePopup"
    //   },
    // }).then(async (value) => {
    //   if (value.isConfirmed) {
    //     deleteLegalDocumentFormat({ documentID: selectedDocRow._id }, (data) => {
    //       showResMsg(data.Result_Message, 2000, data.Result_Status);
    //       data.Result_Status && LoadInitialData();
    //     }, dispatch)
    //   }
    // });
  }
  const documentColumns = [
    {
      // name: "Document Name",
      name: <p style={{ fontSize: "12px" }}>Document Name</p>,
      // selector: (row) => row.documentName,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.documentName}</span>
      ),
      sortable: true,
      sortField: "name",
      style: { paddingLeft: "10px" },
    },
    {
      // name: "Document Remarks",
      name: <p style={{ fontSize: "12px" }}>Document Remarks</p>,
      // selector: (row) => row.documentRemark,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.documentRemark}</span>
      ),
      sortable: true,
      sortField: "name",
      style: { paddingLeft: "10px" },
    },
    {
      // name: "Action(s)",
      name: <p style={{ fontSize: "12px" }}>Action(s)</p>,
      selector: (row) => row,
      center: true,
      cell: row => <IconMenu size="small" row={
        <>
          {/* <Grid container justifyContent={"center"} mr={2} spacing={4} mt={-6.2}> */}
          <Grid style={{ width: "100%" }} item>
            <p style={darkMode ? { color: "white" } : { color: "black" }} onClick={() => { handleEditDocument(row) }}>
              <TimelineItem color="success" icon="edit" title="Edit"
                onClick={() => { handleEditDocument(row) }}
              />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Edit</p>

          </Grid>
          <Grid style={{ width: "100%" }} item>
            <p style={darkMode ? { color: "white" } : { color: "black" }} onClick={() => { handleViewDocument(row) }}>
              <TimelineItem
                color="info"
                icon="visibility"
                onClick={() => { handleViewDocument(row) }}
                title="View"
              // disabled={SCREEN_RIGHT === "View Only"}
              />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;View</p>
          </Grid>
          <Grid style={{ width: "100%" }} item>
            <p style={darkMode ? { color: "white" } : { color: "black" }} onClick={() => handleDeleteDocument(row)}>
              <TimelineItem
                color="error"
                icon="delete"
                onClick={() => handleDeleteDocument(row)}
                title="Delete"
                disabled={SCREEN_RIGHT === "View Only"}
              />  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Delete</p>
          </Grid>
          {/* </Grid> */}
        </>
      } />,
    },
  ];
  const isButtonDisabled = !values.documentName && !file;
  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox mt={3} mb={3}>
        <Grid container spacing={1} style={{ display: "flex", justifyContent: "center" }}>
          <Grid item lg={12} xs={12}>
            <Card sx={{ boxShadow: "none", paddingBottom: "20px" }}>
              <MDBox
                mx={2}
                mt={-3}
                mb={1.5}
                py={0.4}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">Upload Legal Documents</MDTypography>
              </MDBox>
              <MDBox>
                <Grid container px={2} py={0.7} spacing={3} mb={2}>

                  <Grid item lg={3} xs={4}>
                    <TextField
                      type="text"
                      label="Document Name"
                      style={{ paddingTop: "9px !important" }}
                      variant="outlined"
                      fullWidth
                      inputProps={{
                        maxLength: 30,
                        pattern: "^[a-zA-Z0-9 ]+$",
                      }}
                      value={values.documentName}
                      onChange={handleChange('documentName')}
                      autoFocus={true}
                    />
                  </Grid>
                  <Grid item lg={3} xs={4}>
                    <TextField
                      type="text"
                      label="Document Remark"
                      variant="outlined"
                      style={{ paddingTop: "9px !important" }}
                      fullWidth
                      inputProps={{
                        maxLength: 100,
                      }}
                      value={values.documentRemark}
                      onChange={handleChange('documentRemark')}
                    />
                  </Grid>
                  <Grid item xs={12} lg={3.7}>
                    <label htmlFor="fileInput">
                      <TextField
                        id="legalDocument"
                        type="text"
                        label="Document File"
                        style={{ paddingTop: "9px !important" }}
                        variant="outlined"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          readOnly: true,
                          endAdornment: (
                            <InputAdornment position="end">
                              <label className="ress" htmlFor="fileInput">
                                <Button variant="contained" component="span" size="small" allign="right" style={{ color: 'white' }} >Choose File</Button>
                              </label>
                            </InputAdornment>
                          ),
                        }}
                      />
                      <input
                        type="file"
                        accept=".pdf"
                        id="fileInput"
                        style={{ display: "none" }}
                        onChange={saveFile}
                      />
                    </label>
                    <p style={errMsg}>{fileError}</p>
                  </Grid>

                  <Grid item xs={12} md={4} spacing={2} lg={1.8}>
                    <MDButton
                      rel="noreferrer"
                      variant="gradient"
                      color="success"
                      className="uploadbtn"
                      fullWidth
                      disabled={isButtonDisabled}
                      onClick={addDocument}
                    >Upload Document
                    </MDButton>
                  </Grid>


                </Grid>
                <Grid container px={2} spacing={3}>
                  <Grid item xs={12} md={4} lg={12}>
                    <MDTypography
                      variant="button"
                      fontWeight="bold"
                      color="text"
                      sx={{ userSelect: "none" }}
                    >
                      Uploaded Documents Details
                    </MDTypography>
                  </Grid>
                </Grid>
                {documentFormat.length > 0 &&
                  <CardContent sx={{ width: "100%", marginTop: "-10px" }}>
                    <DataTable
                      theme={darkMode ? "solarized" : "light"}
                      columns={documentColumns}
                      data={documentFormat}
                      // fixedHeaderScrollHeight="210px"
                      fixedHeader={true}
                      customStyles={customStyles}

                    />
                  </CardContent>}
              </MDBox>

            </Card>
          </Grid >
        </Grid >
      </MDBox >

      <Modal
        open={viewDocumentInModal}
        onClose={() => setViewDocumentInModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          '& .MuiModal-root': {
            width: '100%',
            height: '100%',
          },
        }}
      >
        {/* <Card sx={pdfStyle}>
          <Box>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
            >
              Document Viewer
            </Typography>
            <iframe title="Document Viewer" src={getDocumentFileURL} width="100%" height="650" frameBorder="0" allowFullScreen={true}></iframe>

            <Grid container id="modal-modal-description" sx={{ mt: 2, justifyContent: "center" }}>
              <MDButton color="warning" className="modalButton" onClick={() => { setViewDocumentInModal(false) }}>

                Close
              </MDButton>
            </Grid>
          </Box>
        </Card> */}



        <Card sx={{ ...pdfStyle, border: "none", width: { xs: "95%", sm: "90%", md: "80%" }, maxWidth: "1200px" }}>
          <Box>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              sx={{ fontSize: { xs: "1.5rem", sm: "1.75rem" } }}
            >
              Document Viewer
            </Typography>
            <Box sx={{ width: "100%", height: { xs: "60vh", sm: "70vh" }, overflow: "hidden" }}>
              <iframe
                title="Document Viewer"
                src={getDocumentFileURL}
                width="100%"
                height="100%"
                frameBorder="0"
                allowFullScreen
                style={{ display: 'block' }}
              ></iframe>
            </Box>
            <Grid container id="modal-modal-description" sx={{ mt: 2, justifyContent: "center" }}>
              <MDButton
                color="warning"
                className="modalButton"
                onClick={() => { setViewDocumentInModal(false) }}
                sx={{ fontSize: "1rem", padding: "0.5rem 1rem" }}
              >
                Close
              </MDButton>
            </Grid>
          </Box>
        </Card>
      </Modal>

    </DashboardLayout >
  );
}

export default DefaultSetting;
